// PrivacyPolicyPage.js
import { useEffect, useState } from "react";
import React from 'react';
import './PrivacyPolicy.css'

const PrivacyPolicy = () => {
    const [content, setContent] = useState("");

    useEffect(() => {
        fetch("/privacy-policy.html")
            .then((response) => response.text())
            .then((html) => setContent(html))
            .catch((error) => console.error("Error loading privacy policy:", error));
    }, []);

    return (
        <section className='privacy-policy-container'>
            <div className='privacy-policy-content'>
                <div className="privacy-policy-body" dangerouslySetInnerHTML={{ __html: content }} />
            </div>
        </section>
    );
};

export default PrivacyPolicy;
